import React, { useState, useEffect } from 'react';

import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


const toggleAsc = (setState, item, callBack) => {
  setState(item);
  if(callBack) {
    callBack(item)
  }
}

const toggleDesc = (setState, item, callBack) => {
  setState(item);
  if(callBack) {
    callBack(item)
  }
}

function OrderAscDesc({ defaultActive, callBack }) {

  const { t } = useTranslation();

  const options = [
    {
      id: 1,
      name: t('ASC'),
      value: 'ASC',
      func: toggleAsc
    },
    {
      id: 2,
      name: t('DESC'),
      value: 'DESC',
      func: toggleDesc
    }
  ];
  
  const findDefaultActive = (defaultActive) => {
    let defaultValue = defaultActive && defaultActive.trim() !== '' ? defaultActive.toUpperCase().trim() : null;
    if(defaultValue !== null) {
      defaultValue = defaultValue.match("DESC") || defaultValue.match("ASC") ? defaultValue === 'ASC' ? options[0].value : options[1].value : null;
    }
    return defaultValue;
  }
  
  const [ active, setActive ] = useState(findDefaultActive(defaultActive))


  
  useEffect(() => {
    setActive(findDefaultActive(defaultActive));
  }, [defaultActive])

  return (
    <div className={styles.wrapperOrderAsc}>
      {options.map(opt => {
        return (<button key={opt.id}
                  onClick={() => opt.func(setActive, opt.value, callBack)}
                  className={[styles.button, opt.value === active ? styles.active : ''].join(' ')}
                >
                    {opt.name}
                </button>)
      })}
  </div>
  );
}

export default OrderAscDesc;
